import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SttTable } from '../all';
import { fullName } from '../../lib/utils';

type ActivityParticipants = {
    id: number;
    user: {
        fullName: string;
        mship: {
            fullName: string;
        };
    };
};
export default function SignedUsersList({
    items,
}: {
    items: Array<ActivityParticipants>;
}) {
    const { t } = useTranslation();
    const [signedUsers] = useState(items);

    return (
        <SttTable
            data={{
                rows: signedUsers,
                count: signedUsers.length,
            }}
            columns={[
                {
                    title: t('fullname'),
                    align: 'left',
                    value: (value: ActivityParticipants) =>
                        fullName(value?.user),
                },
            ]}
            onFetch={undefined}
            loadingValue={undefined}
            onClickRow={undefined}
            linkTo={undefined}
            totals={undefined}
            selection={undefined}
            selectRows={undefined}
            setSelectRows={undefined}
            forceUpdateSwitch={undefined}
        />
    );
}
